import React from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "What mobile app development services do you offer?",
    answer: `<p>We offer comprehensive mobile app development services, including:</p>
            <ul>
            <li>Custom mobile app design and development</li>
            <li>Native app development for iOS and Android platforms</li>
            <li>Cross-platform app development using frameworks like React Native and Flutter</li>
            <li>UI/UX design and optimization</li>
            <li>App testing, debugging, and quality assurance</li>
            <li>App deployment and maintenance support</li>
</ul>`,
  },
  {
    question: "What is the average cost and timeline for developing software?",
    answer: `<p>The cost and timeline for developing a software can vary significantly based on factors such as:</p>
      <ul>
        <li>Project complexity and functionality</li>
        <li>Platform compatibility (iOS, Android, or both)</li>
        <li>Design requirements (basic UI/UX vs. custom design)</li>
        <li>Integration with third-party APIs or systems</li>
        <li>Post-launch maintenance and support needs</li>
      </ul>
      <p>For a rough estimate, the overall cost of software development can range from $30,000 to $300,000 or more. Similarly, the timeline can vary from 3 to 15 months, depending on the app's complexity and features.</p>

      `,
  },
  {
    question: "Do you offer ongoing maintenance and support services?",
    answer: `<p>Yes, we provide comprehensive project maintenance and support services post-launch. Our services include:</p>
      <ul>
        <li>Regular app updates and feature enhancements</li>
        <li>Bug fixing and performance optimization</li>
        <li>Security patches and data backup</li>
        <li>User feedback analysis and implementation of improvements</li>
        <li>Technical support and troubleshooting</li>
      </ul>
    `,
  },
  {
    question: "Do you develop software for both mobile and web platforms?",
    answer: `<p>Yes, we specialize in developing software solutions for both mobile and web platforms. Our services include:</p>
      <ul>
        <li>Custom web application development</li>
        <li>Mobile app development for iOS and Android platforms</li>
        <li>Progressive web app (PWA) development</li>
        <li>Responsive web design and optimization</li>
        <li>Web-based software solutions for enterprise needs</li>
      </ul>
`,
  },
  {
    question: "What software development services do you offer?",
    answer: `
    <p>Our software development services encompass a wide range of solutions, including:</p>
    <ul>
      <li>Custom software design and development</li>
      <li>Enterprise software solutions for business management and operations</li>
      <li>E-commerce platforms and online marketplace development</li>
      <li>CRM (Customer Relationship Management) systems</li>
      <li>IoT (Internet of Things) software solutions</li>
      <li>Data analytics and business intelligence software</li>
      <li>Cloud-based custom solutions</li>
    </ul>
`,
  },
  {
    question:
      "How do you ensure the security and quality of the software you develop?",
    answer: `
    <p>We follow industry best practices and stringent quality assurance measures to ensure the security and quality of the software we develop. Our approach includes:</p>
    <ul>
      <li>Conducting thorough code reviews and testing procedures</li>
      <li>Implementing secure coding practices and encryption standards</li>
      <li>Regular security audits and vulnerability assessments</li>
      <li>Adhering to compliance standards and regulations (such as GDPR, HIPAA, etc.)</li>
      <li>Continuous monitoring and updates to address emerging threats</li>
    </ul>
`,
  },
  {
    question: "Do you assist with software integration and data migration?",
    answer: `
    <p>Yes, we provide software integration and data migration services to ensure seamless compatibility and data transfer between different systems. Our services include:</p>
    <ul>
      <li>Integration with third-party APIs, plugins, and platforms</li>
      <li>Legacy system integration and modernization</li>
      <li>Data migration from legacy systems to new software solutions</li>
      <li>Middleware development for efficient data exchange</li>
      <li>Testing and validation of integrated systems to ensure smooth operation</li>
    </ul>
  `,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg home overflow-x-hidden">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div
              className="example example-bottom center text-center"
              data-text="FAQs"
            >
              <h2>Frequently Asked Questions</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
